import { extractPortNumber } from './utils';

export function getPortSlotKey(port) {
  const num = extractPortNumber(port.interface);
  if (num != null) return `port-${num}`;
  return `port-${port._id}`;
}

export function portNumberToGridIndex(portNum, config) {
  const { portCount, portRows, topRowNumbering } = config;
  if (portNum < 1 || portNum > portCount) return null;

  const colsPerRow = Math.ceil(portCount / portRows);

  if (portRows === 1) {
    return portNum - 1;
  }

  const col = Math.floor((portNum - 1) / 2);
  const isOdd = portNum % 2 === 1;
  const onTopRow =
    topRowNumbering === 'odd' ? isOdd : !isOdd;
  const row = onTopRow ? 0 : 1;
  return row * colsPerRow + col;
}

export function gridIndexToPortNumber(index, config) {
  const { portCount, portRows, topRowNumbering } = config;
  const colsPerRow = Math.ceil(portCount / portRows);

  if (portRows === 1) {
    return index + 1;
  }

  const row = Math.floor(index / colsPerRow);
  const col = index % colsPerRow;
  const topIsOdd = topRowNumbering === 'odd';

  if (row === 0) {
    return topIsOdd ? col * 2 + 1 : col * 2 + 2;
  }
  return topIsOdd ? col * 2 + 2 : col * 2 + 1;
}

export function buildPortSlotArray(config) {
  const { portCount, portRows } = config;
  const colsPerRow = Math.ceil(portCount / portRows);
  const totalSlots = colsPerRow * portRows;
  return Array.from({ length: totalSlots }, () => null);
}

export function getSwitchPortIndex(port, config) {
  const num = extractPortNumber(port.interface);
  if (num == null) return null;

  const portCount = config?.portCount ?? 48;
  const sfpCount = config?.sfpCount ?? 6;

  if (num <= portCount) {
    const index = portNumberToGridIndex(num, config);
    if (index == null) return null;
    return { section: 'rj45', index };
  }

  if (num <= portCount + sfpCount) {
    return { section: 'sfp', index: num - portCount - 1 };
  }

  return null;
}

export function getPatchPanelPortIndex(port, totalPorts = 24) {
  const num = extractPortNumber(port.interface);
  if (num == null) return null;
  return Math.min(Math.max(num - 1, 0), totalPorts - 1);
}

export function buildSfpSlotArray(config) {
  const { sfpCount, sfpRows } = config;
  const colsPerRow = Math.ceil(sfpCount / sfpRows);
  return Array.from({ length: colsPerRow * sfpRows }, () => null);
}
